module.exports = __webpack_public_path__ + "img/utilitarios.d3091547.jpg";